export enum ENUM__image_orientation {
  HORIZONTAL = 'horizontal',
  SQUARE = 'square',
  VERTICAL = 'vertical',
}
